import { TESTIMONIOS } from '@/lib/constants';

function Stars({ count }: { count: number }) {
  const full = Math.floor(count);
  const hasHalf = count - full >= 0.5;
  return (
    <div className="stars">
      {Array.from({ length: full }).map((_, i) => (
        <i key={`f${i}`} className="fa fa-star" />
      ))}
      {hasHalf && <i className="fa fa-star-half-stroke" />}
    </div>
  );
}

export function Testimonios() {
  return (
    <section id="testimonios">
      <div className="wrap">
        <span className="eyebrow reveal">Lo que dicen</span>
        <h2 className="st reveal">NUESTROS CLIENTES</h2>
        <div className="testi-grid">
          {TESTIMONIOS.map((t, i) => (
            <div key={t.nombre} className={`testi-card reveal d${i + 1}`}>
              <Stars count={t.stars} />
              <div className="testi-quote">"</div>
              <p>{t.quote}</p>
              <div>
                <div className="testi-name">{t.nombre}</div>
                <div className="testi-role">{t.rol}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
